import { IIconProps } from '../../types/IconProps.interface'

export const IconDotsVertical = ({ color = 'white' }: IIconProps) => {
  return (
    <svg className='w-full' fill={color} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0 0h24v24H0z' fill='none' stroke='none' />
      <path d='M14 12a2 2 0 1 1 -4 0q 0 -.053 .005 -.102a1.996 1.996 0 0 1 1.995 -1.898a2 2 0 0 1 2 2' />
      <path d='M14 19a2 2 0 1 1 -4 0q 0 -.052 .005 -.102a1.996 1.996 0 0 1 1.995 -1.898a2 2 0 0 1 2 2' />
      <path d='M14 5a2 2 0 1 1 -4 0q 0 -.053 .005 -.102a1.996 1.996 0 0 1 1.995 -1.898a2 2 0 0 1 2 2' />
    </svg>
  )
}
